// extracted by mini-css-extract-plugin
export default {"searchForm":"SimpleSearch_searchForm__EAEs6","searchInput":"SimpleSearch_searchInput__Fu+ht","searchButton":"SimpleSearch_searchButton__uL56G"};